module.exports = __webpack_public_path__ + "img/out-step1-en.24034300.png";